import React from 'react'
import { ShevronLeftIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronLeftIcon'
import { ShevronRightIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronRightIcon'
import type { ISwiperArrowProps } from '@/components/ui/SwiperArrow/interfaces'
import { Button } from '..'

const SwiperArrow: React.FC<ISwiperArrowProps> = ({ onClick, modifier = 'swiper-white', isDisabled, className, direction }) => (
  <Button
    modifiers={[modifier]}
    onClick={onClick}
    iconProps={{ component: direction === 'right' ? <ShevronRightIcon /> : <ShevronLeftIcon /> }}
    className={className}
    isDisabled={isDisabled}
  />
)

export default SwiperArrow
